module.exports = __webpack_public_path__ + "static/media/AllRecipes-NLPRounded.19690e0f.png";